export default __webpack_public_path__ + "static/media/1771.1a188f5c.png";